var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menubuilder__tselector" }, [
    _c("h3", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.extrasTitle.value,
            expression: "extrasTitle.value"
          }
        ],
        staticClass: "menubuilder__othertitle",
        attrs: { type: "text", name: "menubuilder__othertitle" },
        domProps: { value: _vm.extrasTitle.value },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.extrasTitle, "value", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c("label", { staticClass: "menubuilder__edit" }, [
        _c(
          "span",
          {
            staticClass: "help-icon",
            on: {
              click: function($event) {
                return _vm.toggleTooltip()
              }
            }
          },
          [_vm._v("?")]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "tooltip", class: { active: _vm.showTooltip } },
          [_vm._v("\n        " + _vm._s(_vm.extrasHelpText.value) + "\n      ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.extras, function(extra, index) {
        return _c("li", { key: index }, [
          _c(
            "span",
            {
              staticClass: "plus",
              on: {
                click: function($event) {
                  return _vm.remove(extra)
                }
              }
            },
            [_c("span", [_vm._v("-")])]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: extra.name,
                expression: "extra.name"
              }
            ],
            staticClass: "menubuilder__ttitle",
            domProps: { value: extra.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(extra, "name", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: extra.price,
                expression: "extra.price"
              }
            ],
            staticClass: "menubuilder__tprice",
            attrs: { type: "text" },
            domProps: { value: extra.price },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(extra, "price", $event.target.value)
              }
            }
          })
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "menubuilder__add", on: { click: _vm.addExtra } },
      [_vm._m(0), _vm._v(" "), _c("span", [_vm._v("Add an extra")])]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "plus" }, [_c("span", [_vm._v("+")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/MenuBuilder/ExtrasSelector.vue?vue&type=template&id=368b5a8a&
// module id = 151
// module chunks = 3